/**
 * Converts camelCase to dash-case.
 *
 * For example, if you call camelToDashCase('camelCaseString'), it will return 'camel-case-string'.
 *
 * @param s camelCase string
 * @returns dash-case string
 */
export const camelToDashCase = (s: string) => s.replace(/[A-Z]/g, m => '-' + m.toLowerCase());

/**
 * Creates a lightweight hash from a string without crypto api (e.g., map keys, checksums).
 * The same input will always produce the same output.
 *
 * @param input - The string to hash.
 * @returns A 32-bit integer hash as a string.
 */
export const simpleHash32 = (s: string) => (Array.from(s).reduce((h, c) => (h << 5) - h + c.charCodeAt(0), 0) >>> 0).toString(16);
